// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1dr7_","noInteraction":"EventWrapper_noInteraction__2VJQE"};